import { Component, EventEmitter, Input, Output } from '@angular/core';

import { VehiclesImportedHistoryModel } from './typings/vehicles.imported-history';

@Component({
  selector   : 'wor-imported-history-actions',
  template: require('./vehicle.imported-history.actions.component.html')
})
export class VehicleImportedHistoryActionsComponent {
  @Input() record: VehiclesImportedHistoryModel;

  @Output() onNotesClick: EventEmitter<VehiclesImportedHistoryModel> = new EventEmitter();
  @Output() onPrintClick: EventEmitter<VehiclesImportedHistoryModel> = new EventEmitter();
}
